import { useCallback } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Slider } from '@hivebrite/design-system/Slider';
import type { ColorName } from '@hivebrite/design-system/Theme';

import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { SliderItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/galleryItemAttributes';

import type { SliderCardProps } from './SliderCard';
import SliderCard from './SliderCard';

export interface SliderItemUIProps {
  fontFamily?: string;
  item: DocumentItem;
  subdomainNetworkUrl?: string;
  textColor?: ColorName;
  toggleDrawer?: (args: DocumentItem<SliderItemAttributes>) => void;
}

const SliderItemUI = ({
  fontFamily,
  item,
  subdomainNetworkUrl,
  textColor,
  toggleDrawer,
}: SliderItemUIProps) => {
  const handleClickSliderItem = (item: SliderCardProps['item']) => () => {
    toggleDrawer?.(item);
  };
  const items = item.children || [];

  const renderItem = useCallback(
    (childItem) => {
      const props = {
        fontFamily,
        subdomainNetworkUrl,
        textColor,
        onClickSliderItem: handleClickSliderItem(childItem),
      };

      return <SliderCard item={childItem} {...props} />;
    },
    [fontFamily, subdomainNetworkUrl, textColor, toggleDrawer],
  );

  return (
    <SliderWrapper>
      <Slider
        items={items}
        loading={false}
        renderItemComponent={renderItem}
        renderLoadingItemComponent={() => <div />}
        total={items.length}
      />
    </SliderWrapper>
  );
};

export default SliderItemUI;

const SliderWrapper = styled(Box).attrs(() => ({
  my: 6,
  width: '100%',
}))`
  .slider-container {
    width: 100%;
  }
`;
